import 'babel-polyfill';
import 'raf/polyfill';
import 'react-hot-loader';
import { render } from 'react-dom';
import React from 'react';

import '@fontsource/noto-sans';
import 'react-table/react-table.css';
import { activateLogger } from './Shared/UIEventLogger/UIEventLogger';
import configureStore from './Root/RootStore/configureStore';
import RootContainer from './Root/RootContainer';

activateLogger();

const rootEl = document.getElementById('root');

render(<RootContainer store={configureStore} />, rootEl);



// WEBPACK FOOTER //
// ./src/index.js